/**
 * Librería de íconos (Font Awesome, ya cargado por CDN en `public/index.html`)
 * que un administrador puede elegir para una categoría sin subir su propia
 * imagen (HU-009-C) — alternativa a `cat_fileLogo`, guardada en
 * `cat_chIconoPreset`. Los primeros `CANTIDAD_FRECUENTES` son los de uso más
 * común en denuncias municipales y son los que se muestran directo en el
 * formulario (HU-014); el resto solo aparece al abrir "Ver más íconos"
 * (`ModalSelectorIcono.jsx`), que busca sobre la lista completa.
 */
export const ICONOS_PRESET_CATEGORIA = [
  // -- Frecuentes (se muestran siempre, sin abrir el buscador) --
  { clase: 'fa-road', etiqueta: 'Vía/pista' },
  { clase: 'fa-traffic-light', etiqueta: 'Semáforo' },
  { clase: 'fa-signs-post', etiqueta: 'Señalización' },
  { clase: 'fa-lightbulb', etiqueta: 'Alumbrado' },
  { clase: 'fa-faucet-drip', etiqueta: 'Agua/desagüe' },
  { clase: 'fa-trash', etiqueta: 'Basura/limpieza' },
  { clase: 'fa-volume-high', etiqueta: 'Ruido' },
  { clase: 'fa-shield-halved', etiqueta: 'Seguridad' },
  { clase: 'fa-tree', etiqueta: 'Áreas verdes' },
  { clase: 'fa-paw', etiqueta: 'Animales' },
  { clase: 'fa-car', etiqueta: 'Tránsito/vehículos' },
  { clase: 'fa-person-walking', etiqueta: 'Peatones' },
  { clase: 'fa-house-crack', etiqueta: 'Infraestructura' },
  { clase: 'fa-bolt', etiqueta: 'Energía eléctrica' },
  { clase: 'fa-fire', etiqueta: 'Incendio' },
  { clase: 'fa-water', etiqueta: 'Inundación' },
  { clase: 'fa-user-injured', etiqueta: 'Accidente' },
  { clase: 'fa-store', etiqueta: 'Comercio' },
  { clase: 'fa-triangle-exclamation', etiqueta: 'Genérico' },

  // -- Vías y tránsito --
  { clase: 'fa-road-circle-exclamation', etiqueta: 'Vía en mal estado' },
  { clase: 'fa-road-barrier', etiqueta: 'Barrera vial' },
  { clase: 'fa-truck', etiqueta: 'Camión' },
  { clase: 'fa-truck-ramp-box', etiqueta: 'Carga y descarga' },
  { clase: 'fa-bus', etiqueta: 'Transporte público' },
  { clase: 'fa-car-side', etiqueta: 'Taxi/vehículo' },
  { clase: 'fa-motorcycle', etiqueta: 'Motocicleta' },
  { clase: 'fa-bicycle', etiqueta: 'Bicicleta' },
  { clase: 'fa-charging-station', etiqueta: 'Electrolinera' },
  { clase: 'fa-gas-pump', etiqueta: 'Grifo/combustible' },
  { clase: 'fa-square-parking', etiqueta: 'Estacionamiento' },
  { clase: 'fa-route', etiqueta: 'Ruta' },
  { clase: 'fa-map-location-dot', etiqueta: 'Ubicación' },
  { clase: 'fa-map-pin', etiqueta: 'Punto de referencia' },

  // -- Servicios básicos --
  { clase: 'fa-toilet', etiqueta: 'Servicios higiénicos' },
  { clase: 'fa-faucet', etiqueta: 'Agua potable' },
  { clase: 'fa-sink', etiqueta: 'Desagüe' },
  { clase: 'fa-hand-holding-droplet', etiqueta: 'Escasez de agua' },
  { clase: 'fa-plug', etiqueta: 'Electricidad' },
  { clase: 'fa-plug-circle-exclamation', etiqueta: 'Falla eléctrica' },
  { clase: 'fa-tower-broadcast', etiqueta: 'Antena/telecom' },
  { clase: 'fa-wifi', etiqueta: 'Internet' },
  { clase: 'fa-recycle', etiqueta: 'Reciclaje' },
  { clase: 'fa-dumpster', etiqueta: 'Contenedor de basura' },
  { clase: 'fa-dumpster-fire', etiqueta: 'Quema de basura' },
  { clase: 'fa-broom', etiqueta: 'Limpieza pública' },

  // -- Seguridad y emergencias --
  { clase: 'fa-user-shield', etiqueta: 'Vigilancia' },
  { clase: 'fa-handcuffs', etiqueta: 'Delincuencia' },
  { clase: 'fa-explosion', etiqueta: 'Explosión' },
  { clase: 'fa-fire-extinguisher', etiqueta: 'Riesgo de incendio' },
  { clase: 'fa-truck-medical', etiqueta: 'Ambulancia' },
  { clase: 'fa-kit-medical', etiqueta: 'Primeros auxilios' },
  { clase: 'fa-hospital', etiqueta: 'Hospital/posta' },
  { clase: 'fa-house-chimney-crack', etiqueta: 'Vivienda dañada' },
  { clase: 'fa-person-falling', etiqueta: 'Caída de persona' },
  { clase: 'fa-person-drowning', etiqueta: 'Ahogamiento' },
  { clase: 'fa-life-ring', etiqueta: 'Salvavidas' },
  { clase: 'fa-bell', etiqueta: 'Alarma' },
  { clase: 'fa-eye', etiqueta: 'Cámara de vigilancia' },
  { clase: 'fa-video', etiqueta: 'Videovigilancia' },

  // -- Ambiental --
  { clase: 'fa-smog', etiqueta: 'Contaminación del aire' },
  { clase: 'fa-industry', etiqueta: 'Industria/fábrica' },
  { clase: 'fa-leaf', etiqueta: 'Área verde' },
  { clase: 'fa-seedling', etiqueta: 'Vivero municipal' },
  { clase: 'fa-mountain', etiqueta: 'Zona natural' },
  { clase: 'fa-cloud-rain', etiqueta: 'Lluvia' },
  { clase: 'fa-house-flood-water', etiqueta: 'Vivienda inundada' },
  { clase: 'fa-temperature-high', etiqueta: 'Ola de calor' },
  { clase: 'fa-temperature-low', etiqueta: 'Ola de frío' },
  { clase: 'fa-wind', etiqueta: 'Viento fuerte' },
  { clase: 'fa-bug', etiqueta: 'Plagas' },
  { clase: 'fa-cow', etiqueta: 'Animal en la vía' },
  { clase: 'fa-dog', etiqueta: 'Perro/mascota' },
  { clase: 'fa-cat', etiqueta: 'Gato' },
  { clase: 'fa-crow', etiqueta: 'Ave' },
  { clase: 'fa-fish', etiqueta: 'Fauna acuática' },

  // -- Infraestructura urbana --
  { clase: 'fa-building', etiqueta: 'Edificio' },
  { clase: 'fa-building-circle-exclamation', etiqueta: 'Edificio en riesgo' },
  { clase: 'fa-door-open', etiqueta: 'Acceso/puerta' },
  { clase: 'fa-stairs', etiqueta: 'Escaleras' },
  { clase: 'fa-elevator', etiqueta: 'Ascensor' },
  { clase: 'fa-wheelchair', etiqueta: 'Accesibilidad' },
  { clase: 'fa-child', etiqueta: 'Zona infantil' },
  { clase: 'fa-person-cane', etiqueta: 'Adulto mayor' },
  { clase: 'fa-futbol', etiqueta: 'Cancha deportiva' },
  { clase: 'fa-basketball', etiqueta: 'Losa deportiva' },
  { clase: 'fa-dumbbell', etiqueta: 'Gimnasio público' },
  { clase: 'fa-school', etiqueta: 'Colegio' },
  { clase: 'fa-graduation-cap', etiqueta: 'Educación' },
  { clase: 'fa-book', etiqueta: 'Biblioteca' },
  { clase: 'fa-church', etiqueta: 'Templo' },
  { clase: 'fa-place-of-worship', etiqueta: 'Lugar de culto' },
  { clase: 'fa-landmark', etiqueta: 'Monumento' },
  { clase: 'fa-flag', etiqueta: 'Hito/referencia' },

  // -- Comercio y economía --
  { clase: 'fa-store-slash', etiqueta: 'Comercio informal' },
  { clase: 'fa-shop', etiqueta: 'Tienda' },
  { clase: 'fa-cart-shopping', etiqueta: 'Mercado' },
  { clase: 'fa-money-bill-wave', etiqueta: 'Cobro indebido' },
  { clase: 'fa-hand-holding-dollar', etiqueta: 'Estafa' },
  { clase: 'fa-briefcase', etiqueta: 'Negocio' },
  { clase: 'fa-utensils', etiqueta: 'Restaurante' },
  { clase: 'fa-mug-hot', etiqueta: 'Cafetería' },

  // -- Salud pública --
  { clase: 'fa-virus', etiqueta: 'Enfermedad/epidemia' },
  { clase: 'fa-virus-covid', etiqueta: 'COVID-19' },
  { clase: 'fa-syringe', etiqueta: 'Vacunación' },
  { clase: 'fa-pills', etiqueta: 'Medicamentos' },
  { clase: 'fa-user-doctor', etiqueta: 'Atención médica' },
  { clase: 'fa-house-medical', etiqueta: 'Centro de salud' },

  // -- Convivencia social --
  { clase: 'fa-person-shelter', etiqueta: 'Persona en situación de calle' },
  { clase: 'fa-hands-holding-child', etiqueta: 'Menor en riesgo' },
  { clase: 'fa-people-group', etiqueta: 'Aglomeración' },
  { clase: 'fa-bullhorn', etiqueta: 'Perturbación/protesta' },
  { clase: 'fa-music', etiqueta: 'Ruido - música' },
  { clase: 'fa-smoking', etiqueta: 'Fumar en área prohibida' },
  { clase: 'fa-wine-bottle', etiqueta: 'Consumo de alcohol en vía pública' },
];

/** Cantidad de íconos "frecuentes" que se muestran siempre, sin buscar. */
export const CANTIDAD_ICONOS_FRECUENTES = 19;

/** Ícono que se asigna solo si el administrador no elige ninguno al crear. */
export const ICONO_CATEGORIA_POR_DEFECTO = 'fa-triangle-exclamation';
